const namespance = 'colorTheme'

export const mutations = {
  SET_THEME: `${namespance}/SET_THEME`,
}

export const actions = {
  INITIALIZE: `${namespance}/INITIALIZE`,
}

export const getters = {
  color: `${namespance}/color`,
  logo: `${namespance}/logo`,
  preview: `${namespance}/preview`,
  brandTitle: `${namespance}/brandTitle`,
  favicon: `${namespance}/favicon`,
}

// テーマが取得できなかった時に使用されるデフォルトのテーマ
export const defaultTheme = {
  id: null,
  name: 'default theme',
  color: {
    base1: '#000000',
    base2: '#000000',
    base3: '#000000',
    base1Selected: '#000000',
    okButton: '#ffffff',
    cancelButton: '#ffffff',
  },
  brandTitle: '管理画面',
  logo: {
    large: '',
    small: '',
  },
  preview: {
    image: '',
  },
  favicon:
    'https://s3-ap-northeast-1.amazonaws.com/gl-admin-frontend-logos/default_favicon.png',
}
